import {AfterViewInit, Component, Input, OnInit, ViewChild, ChangeDetectionStrategy} from '@angular/core';
import {MatTableDataSource} from "@angular/material/table";
import {MatSort} from "@angular/material/sort";

export interface ContactsOutletsTable {
  name: string,
  fundUrl: string,
  type: string,
  role: string,
}

@Component({
  selector: 'contacts-outlets-table',
  templateUrl: './contacts-outlets-table.component.html',
  styleUrls: ['./contacts-outlets-table.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone:false
})
export class ContactsOutletsTableComponent implements OnInit, AfterViewInit{
  @Input() outletParticipants: ContactsOutletsTable[]
  public dataSource: MatTableDataSource<ContactsOutletsTable>
  @ViewChild(MatSort) matSort: MatSort
  public outletColumns:string[] = ['name', 'type', 'role']

  ngOnInit() {
    this.dataSource = new MatTableDataSource(this.outletParticipants)
  }
  ngAfterViewInit() {
    this.dataSource.sort = this.matSort
  }

}
